var map = {
	"./blocks/custom/leftTextSliderRight/block.js": 6521,
	"./blocks/custom/reviews/block.js": 14371,
	"./blocks/custom/sponsorSlider/block.js": 62813,
	"./blocks/custom/vacancySlider/block.js": 33574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49363;